module.exports = __webpack_public_path__ + "static/media/1915_sette_cugine_Schiratti_Toniolo_e_Salvioni.8c5ab917.jpg";